import { useState } from 'react';
import API from '../../Services/api';

const FRIENDLY_ERRORS = {
  'Insufficient points': "You don't have enough points for this reward yet. Keep recycling to earn more!",
  'Not enough points': "You don't have enough points for this reward yet. Keep recycling to earn more!",
  'already redeemed': "You've already redeemed this reward.",
  'expired': "Sorry, this reward has expired and is no longer available.",
  'not found': "This reward is no longer available.",
  'not authenticated': "Please log in to redeem rewards.",
  'Unauthorized': "Please log in to redeem rewards.",
};

function friendlyMessage(raw) {
  if (!raw) return "Something went wrong. Please try again in a moment.";
  for (const [key, msg] of Object.entries(FRIENDLY_ERRORS)) {
    if (raw.toLowerCase().includes(key.toLowerCase())) return msg;
  }
  return raw;
}

function RedeemButton({ rewardId, pointsRequired, canAfford }) {
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [redeemed, setRedeemed] = useState(false);

  const handleRedeem = async () => {
    if (!canAfford) {
      setError("You don't have enough points for this reward yet. Keep recycling to earn more!");
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const response = await API.post('/rewards/redeem', { rewardId });
      setMessage(response.data.message || 'Reward redeemed successfully! Check your email for details.');
      setRedeemed(true);
    } catch (err) {
      const raw = err.response?.data?.error || err.response?.data?.message || '';
      setError(friendlyMessage(raw));
    } finally {
      setLoading(false);
    }
  };

  if (redeemed) {
    return (
      <div className="flex flex-col gap-1.5 w-full">
        <div className="flex items-center justify-center gap-2 w-full py-2.5 rounded-xl text-sm font-semibold bg-green-100 text-green-700">
          <i className="fas fa-check-circle"></i>
          {message || 'Redeemed! Check your email for details.'}
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-1.5">
      <button
        onClick={handleRedeem}
        disabled={loading || !canAfford}
        className={`w-full py-2.5 rounded-xl text-sm font-semibold flex items-center justify-center gap-2 transition-all duration-200
          ${canAfford
            ? 'bg-[#004d3f] text-white hover:bg-[#003d32] disabled:opacity-60 disabled:cursor-not-allowed'
            : 'bg-gray-100 text-gray-400 cursor-not-allowed'}`}
      >
        {loading ? (
          <><i className="fas fa-spinner fa-spin"></i> Processing…</>
        ) : canAfford ? (
          <><i className="fas fa-exchange-alt"></i> Redeem for {pointsRequired} pts</>
        ) : (
          <><i className="fas fa-lock"></i> Not enough points</>
        )}
      </button>
      {error && (
        <p className="text-amber-700 bg-amber-50 text-xs rounded-lg px-3 py-2 flex items-start gap-1.5">
          <i className="fas fa-info-circle mt-0.5 flex-shrink-0"></i>
          <span>{error}</span>
        </p>
      )}
    </div>
  );
}

export default RedeemButton;
